<template>
    <div >
        <el-card v-if="typeNumber != '4'" style="min-height: 300px;margin: 0 200px !important;">
            <template slot="header">
                <div class="clearfix">
                    <div>{{ detail.title }}</div>
                </div>
                <div class="time">发布时间：{{ detail.createTime }}</div>
            </template>
            <div v-html="detail.content"></div>
        </el-card>
        <el-card v-if="typeNumber == '4'" style="min-height: 300px;margin: 0 340px !important;">
            <template slot="header">
                <div class="clearfix">
                    <div>{{ detail.title }}
                        <!-- <el-button size="mini" type="primary" @click="download(detail.filePath, detail.fileName)">下载</el-button> -->
                    </div>
                </div>
                <div class="time">发布时间：{{ detail.createTime }}</div>
            </template>
            <div>{{ detail.description }}</div>
            <br/>
            <p style="font-size: 12px;display: flex;">附件：
                <img src="@/assets/images/download.png" height="20" alt="" srcset="" class="concatItem">
            <a :href="detail.filePath" :download="detail.fileName" style="color: black;">{{ detail.fileName }}</a>
        </p>
        </el-card>
    </div>
</template>

<script>
import home from "@/api/home/index"
import images from "../../assets/images";

export default {
    data() {
        return {
            typeNumber: 1,
            detail: {},
            detailId: ''
        };
    },
    mounted() {
    },
    created() {
        console.log("获取的参数", this.$route.query);
        this.typeNumber = this.$route.query.type;
        if (this.typeNumber == '1') {
            if (sessionStorage.getItem('noticeDetail')) {
                this.detail = JSON.parse(sessionStorage.getItem('noticeDetail'));
            }
        }
        else if (this.typeNumber == '2') {
            this.detailId = this.$route.query.id;
            this.getNewsDetail();
        }
        else if (this.typeNumber == '3') {
            this.detailId = this.$route.query.id;
            this.getPoliciesDetail();
        }
        else if (this.typeNumber == '4') {
            this.detailId = this.$route.query.id;
            this.getRelatedDownloadDetail();
        }
    },
    methods: {
        getNewsDetail() {
            home.getNewsDetail({ id: this.detailId }).then(res => {
                if (res.code == 0) {
                    this.detail = res.data;
                }
            });
        },
        getRelatedDownloadDetail() {
            home.getRelatedDownloadDetail({ id: this.detailId }).then(res => {
                if (res.code == 0) {
                    this.detail = res.data;
                }
            });
        },
        getPoliciesDetail() {
            home.getPoliciesDetail({ id: this.detailId }).then(res => {
                if (res.code == 0) {
                    this.detail = res.data;
                }
            });
        },
        download(url, fileName) {
            // 利用原生fetch直接下载文件
            fetch(url).then(res => res.blob()).then(blob => {
                let eleLink = document.createElement("a");
                eleLink.style.display = "none";
                eleLink.target = "_blank";
                eleLink.setAttribute('download', fileName);
                eleLink.href = URL.createObjectURL(blob);
                document.body.appendChild(eleLink);
                eleLink.click();
                URL.revokeObjectURL(eleLink.href);
                document.body.removeChild(eleLink);
            });
        },
    },
    components: { images }
};
</script>

<style lang="less" scoped>
.clearfix {
    // display: flex;
    // justify-content: space-between;
    // margin: 0 auto;
    font-size: 20px;
    text-align: center;
   font-weight: bold;
}
.time {
        // color: #d51900;
        color: #B2B0B1;
        font-size: 12px;
        padding-left: 80%;
        // text-align: center;
    }
</style>